import { getDefaultAgencySearchBean } from "@wikicasa/common/model/AgencySearchBean";
import { defineStore } from "pinia";
import { ref, computed } from "vue";
export var useAgencySearchBeanStore = defineStore("agencySearchBeanStoreId", () => {
  var agencySearchBean = ref(getDefaultAgencySearchBean());
  var searchBeanAgency = computed(() => agencySearchBean.value);
  var setAgencySearchBean = agencyBean => {
    agencySearchBean.value = agencyBean;
  };
  var setAgencySearchBeanByKey = payload => {
    agencySearchBean.value[payload.key] = payload.value;
  };
  var updateAgencySearchBean = payload => {
    for (var key in payload) {
      agencySearchBean.value[key] = payload[key];
    }
  };
  return {
    agencySearchBean,
    searchBeanAgency,
    setAgencySearchBean,
    setAgencySearchBeanByKey,
    updateAgencySearchBean
  };
});